import { render, staticRenderFns } from "./passReminder.vue?vue&type=template&id=0b51c6cc"
import script from "./passReminder.vue?vue&type=script&lang=js"
export * from "./passReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports